import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatLine } from '@angular/material/grid-list';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-help-text-sheet',
  templateUrl: './help-text-sheet.component.html',
  styleUrls: ['./help-text-sheet.component.scss'],
  imports: [MatNavList, MatListItem, MatLine, MatIconButton, MatIcon, MatButton],
})
export class HelpTextSheetComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<HelpTextSheetComponent>
  ) {}

  ngOnInit(): void {}

  checkIfArray(val: string | any[]): boolean {
    return val instanceof Array ? true : false;
  }

  onClose() {
    this.bottomSheetRef.dismiss();
  }
}
